import {TransactionsArcyList} from '../../types/interfaces/black-list';


export class FetchTransactionsArcy {
  static readonly type = '[transactionsArcy] Fetch All';

  constructor(public payload: TransactionsArcyList[]) {
  }
}
